
namespace Matrix.Dashboards {

    export interface IWidgetOptions {
        __designer?: IDashboardDesigner;
        __getDatasetParams: (property?: string) => { [key: string]: any };
        Title?: string;
        TitleLinkUrl?: string;
        Collapsible?: boolean;
    }
}